import template from '../templates/EmployeesManage.html';
import tooltip from 'helpers/tooltip';
import localStorageUtil from 'helpers/localStorageUtil';
import PaginatedList from 'commons/views/PaginatedList.js';
import loader from 'helpers/loader';

module.exports = PaginatedList.extend({
    events: function() {
        const parentEvents = _.isFunction(PaginatedList.prototype.events) ?
            PaginatedList.prototype.events() : PaginatedList.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'shown.bs.tab a[data-toggle="tab"]': 'switchTab',
            'click .employee-tile': 'selectEmployee',
            'click .js-employee-row': 'onSelectEmployee'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {});

        this.views = [];

        this.collection.on('sync', this.render, this);
        this.collection.fetchPage(undefined, {validate: false});
        this.stopLoader = loader.startFullPage(this.$('table'));
        return this;
    },

    selectEmployee: function(ev) {
        localStorageUtil.removeItem('ytdYear');
        const employeeId = $(ev.currentTarget).attr('data-employee-id');
        app.mainRouter.navigate('employee/' + employeeId, {trigger: true});
    },

    onSelectEmployee: function() {
        localStorageUtil.removeItem('ytdYear');
    },

    switchTab: function(ev) {
        const self = this;
        const $tabBtn = $(ev.currentTarget);

        self.$('a[data-toggle="tab"].btn-selected')
            .toggleClass('btn-selected')
            .toggleClass('btn-white');
        $tabBtn.toggleClass('btn-selected').toggleClass('btn-white');

        localStorageUtil.setItem('peopleManageTab', $tabBtn.attr('data-tab'));

        setTimeout(this.$('.footable').footable, 1);
    },

    render: function() {
        const fetchDependencies = this.collection.map(employee => {
            return employee.fetchPosition()
                .then(() => {
                    if (this.options.archived) {
                        return employee.fetchRemoval();
                    }

                    return Promise.resolve();
                });
        });
        Promise.all(fetchDependencies).then(() => {
            let sortClass = this.collection.getSort().order === 'ascending' ?
                'footable-sorted-desc' : 'footable-sorted';

            const tab = localStorageUtil.getItem('peopleManageTab');
            this.$el.html(template({
                tab:        (tab !== 'list' && tab !== 'tiles') ? 'list' : tab,
                collection: this.collection,
                archived:   this.options.archived,
                idSuffix:   Math.floor(Math.random() * 99999),

                searchTerm: this.collection.getSearchTerm(),
                total:      this.collection.length,
                pagination: this.collection.getPaginationInfo(),
                sort:       this.collection.getSort(),
                employeeDataUrl: app.company.employeeDataUrl()
            }));

            this.$('.footable-sortable')
                .removeClass('footable-sorted-desc')
                .removeClass('footable-sorted');

            this.$('[data-sort="' + this.collection.getSort().key + '"]')
                .addClass(sortClass);

            this.hideLoader();
            tooltip.init(this);
        });
    },

    hideLoader: function() {
        this.stopLoader();
    },

    navigate: function() {
        const status = this.options.archived ? `archived` : `active`;
        const searchTerm = this.collection.getSearchTerm() ?
            `/${this.collection.getSearchTerm()}` : ``;
        app.mainRouter.navigate(`employees/${status}/` +
            `${this.collection.getSort().key}/` +
            `${this.collection.getSort().order}` +
            `${searchTerm}`, {trigger: true});
    },

    remove: function() {
        this.collection.off(null, null, this);
        this.undelegateEvents();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/EmployeesManage.js